<template>
  <div class="event-modal-view">
    <MForm v-bind="formConfig" :model="formConfig.model" />
    <div class="other-method">
      <div class="method-info" v-for="(item, index) in otherMethodConfig.methodList" :key="index">
        <div class="title">{{ $t(item.title) }}</div>

        <div class="method-detail">
          <div class="detail" v-for="(sitem, sindex) in item.deivceInfo" :key="sindex">
            <div class="detail-item">
              <div class="">{{ sitem.name }}</div>
              <div class="">{{ sitem.locationDesc }}</div>
              <div class="">
                <el-switch
                  v-model="sitem.switchState"
                  active-value="1"
                  inactive-value="0"
                  @change="switchChangeHandle(sitem)"
                ></el-switch>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialogHandle">{{ $t('取消') }}</el-button>
      <el-button type="primary" @click="eventDisposalHandle">{{ $t('确定') }}</el-button>
    </div>
  </div>
</template>

<script>
import MForm from '@/components/form/index.vue';
import { emergencyPlanFindAllServer, saveEventServer } from '@/api/air-monitor/alarm-center';
import {
  externalDeviceListAllServer,
  updateExternalDeviceServer
} from '@/api/air-monitor/device-center';
import { isEmpty } from '@/utils/is';
export default {
  components: { MForm },
  props: {
    eventType: {
      type: String,
      default: ''
    },
    disposeInstruction: {
      type: String,
      default: ''
    },
    emergencyPlanId: {
      type: String,
      default: ''
    },
    showType: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      formConfig: {
        i18nPath: 'query',
        config: {
          labelWidth: 'auto',
          span: 24,
          labelSuffix: ':',
          options: [
            {
              disabled: true,
              type: 'input',
              prop: 'name',
              span: 24,
              label: '事件类型'
            },
            {
              disabled: true,
              type: 'input',
              prop: 'disposeInstruction',
              span: 24,
              label: '处置指令'
            },
            {
              disabled: true,
              type: 'select',
              prop: 'emergencyPlanId',
              span: 24,
              label: '应急预案',
              dataKey: 'planList'
            }
          ]
        },
        model: {
          name: this.showType,
          emergencyPlanId: this.emergencyPlanId,
          disposeInstruction: this.disposeInstruction
        },
        dataSource: {
          planList: []
        },
        rules: {}
      },
      otherMethodConfig: {
        methodList: [
          {
            title: '滤毒',
            deivceInfo: []
          },
          {
            title: '通风',
            deivceInfo: []
          }
        ],
        radioList: [
          { key: 0, label: '关' },
          { key: 1, label: '开' }
        ]
      }
    };
  },
  mounted() {
    this.loadExternalDeviceInfo();
    this.loadPlanListHandle();
  },
  methods: {
    loadExternalDeviceInfo() {
      externalDeviceListAllServer().then(res => {
        res.data.forEach(item => {
          if (item.deviceTypeCode === 'ventilate') {
            this.otherMethodConfig['methodList'][1].deivceInfo.push(item);
          } else {
            this.otherMethodConfig['methodList'][0].deivceInfo.push(item);
          }
        });
      });
    },
    loadPlanListHandle() {
      let planList = [];

      emergencyPlanFindAllServer().then(res => {
        if (res.code == 200) {
          if (isEmpty(res.data)) return;

          res.data.forEach(item => {
            planList.push({
              label: item.name,
              value: item.id
            });
          });

          this.formConfig.dataSource.planList = planList;
        }
      });
    },
    closeDialogHandle() {
      this.$emit('closeDialog', false);
    },
    eventDisposalHandle() {
      let obj = {
        id: this.id,
        status: '3'
      };

      saveEventServer(obj).then(res => {
        if (res.code == 200) {
          this.$message.success(this.$t('处置成功'));
          this.$emit('closeDialog', true);
        }
      });
    },
    switchChangeHandle(val) {
      updateExternalDeviceServer(val);
    }
  }
};
</script>

<style scoped lang="scss">
.event-modal-view {
  .other-method {
    // margin-top: 10px;
    height: 300px;
    overflow-y: auto;

    .method-info {
      padding: 0 20px;
      box-sizing: border-box;
      .title {
        text-align: center;
        font-size: 20px;
        font-weight: bold;
        margin-bottom: 20px;
      }
      .method-detail {
        .detail {
          margin-bottom: 25px;
          &-item {
            display: flex;
            align-items: center;
            justify-content: space-between;
          }
        }
      }
    }
  }

  /* 修改滚动条的宽度 */
  .other-method::-webkit-scrollbar {
    width: 5px;
  }

  /* 修改滚动条的轨道颜色 */
  .other-method::-webkit-scrollbar-track {
    background-color: var(--mtable-bg-color);
  }

  /* 修改滚动条的滑块颜色和圆角 */
  .other-method::-webkit-scrollbar-thumb {
    background-color: var(--mtable-color);
    border-radius: 50px;
  }

  /* 修改滚动条的滑块在hover状态下的颜色 */
  //   .other-method::-webkit-scrollbar-thumb:hover {
  //     background-color: #555;
  //   }

  .dialog-footer {
    text-align: right;
  }
}
</style>
